import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BeneficiaryDetailsChanges } from '../../../beneficiaries/models/beneficiary-details-changes';
import { SubmissionStateEnum } from '../../../../models/users/enum/submission-state-enum';
import { BehaviorSubject, Observable } from 'rxjs';
import { BeneficiarySubmissionUtils } from '../../../beneficiaries/utils/beneficiary-submission-utils';
import { CommonModule } from '@angular/common';
import { SubmissionDetailComponent } from '../submission-detail-grid/submission-detail/submission-detail.component';
import { PreviousNotApplicablePipe } from '../../pipes/previous-not-applicable.pipe';

@Component({
  selector: 'app-beneficiary-details-estate-changes',
  standalone: true,
  imports: [CommonModule, SubmissionDetailComponent, PreviousNotApplicablePipe],
  templateUrl: './beneficiary-details-estate-changes.component.html',
  styleUrls: [
    '../../../../views/shared/components/member-beneficiary-submission-details/member-beneficiary-submission-details.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeneficiaryDetailsEstateChangesComponent implements OnChanges {
  @Input() beneficiaryChanges!: BeneficiaryDetailsChanges;

  private _formattedPrimaryContactInformation = new BehaviorSubject<BeneficiaryDetailsChanges | null>(null);
  public formattedPrimaryContactInformation$ = this
    ._formattedPrimaryContactInformation as Observable<BeneficiaryDetailsChanges>;

  private _hasContactChanges = new BehaviorSubject<boolean>(false);
  public hasContactChanges$ = this._hasContactChanges as Observable<boolean>;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.beneficiaryChanges) {
      const contactChanges = new BeneficiaryDetailsChanges();
      const newContactChangesIndividual = this.beneficiaryChanges.new.find(c => c.label === 'firstName')?.value !== '';
      const previousContactChangesIndividual =
        this.beneficiaryChanges.previous.find(c => c.label === 'firstName')?.value !== '';
      const isIndividualKey = (key: string) =>
        ['firstName', 'lastName', 'phoneNumber', 'phoneNumberCountryCode'].includes(key);

      const isOrgKey = (key: string) =>
        key === 'organizationName' || key === 'organizationPhoneNumber' || key?.startsWith('address');

      const filterChanges = (changeList: any[], predicate: (key: string) => boolean) =>
        changeList
          .filter(change => predicate(change.label))
          .map(c => BeneficiarySubmissionUtils.formatBeneficiaryDetailsChanges(c));

      contactChanges.new = filterChanges(
        this.beneficiaryChanges.new,
        newContactChangesIndividual ? isIndividualKey : isOrgKey
      );
      contactChanges.previous = filterChanges(
        this.beneficiaryChanges.previous,
        previousContactChangesIndividual ? isIndividualKey : isOrgKey
      );

      this._hasContactChanges.next(contactChanges.new.some(c => c.hasChanged));

      this._formattedPrimaryContactInformation.next(contactChanges);
    }
  }

  protected readonly SubmissionStateEnum = SubmissionStateEnum;
}
